export class ExternalApplication {
  name: string;
  description: string;
  url: string;
  icon: string;
  color: string;
  creationAt: Date;
  updatedAt: Date;
  userId: number;
  uuid: string;
}
